var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_vm._v("商家扫一扫 "),_c('businessTabbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }